import { DatePipe } from '@angular/common';
import { HostListener } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BatchModule } from '../../modelo/batch/batch.module';
import { ConfigEtiquetaModule } from '../../modelo/confiEtiqueta/batch.module';
import { EtiquetaModule } from '../../modelo/etiqueta/etiqueta.module';
import { Recepcion } from '../../modelo/recepcion/recepcion.module';

import { DetalleModule } from '../../modelo/usuario/detalle.module';

import { OrdenModule } from '../../modelo/usuario/orden.module';

import { ConfigetiquetaService } from '../../servicios/configetiqueta.service';
import { ImpresionService } from '../../servicios/impresion.service';
import { OrdenService } from '../../servicios/orden.service';



@Component({
  selector: 'app-ordenes',
  templateUrl: './ordenes.component.html',
  styleUrls: ['./ordenes.component.css']
})
export class OrdenesComponent implements OnInit {

  fecha: string;
  //batch: Batch[];
  lista: OrdenModule[];
  listaConfigEtiqueta: EtiquetaModule[];
  documento: string;
  detalles: DetalleModule[];
  batch:BatchModule[];
  recepcion: Recepcion[];
  recepcionEntidad: Recepcion;
  printers: string[];
  selectedPrinter: any;
  isDefaultPrinterSelected = false;
  habilitarLote: boolean = true;
  searchText: string = '';
  urlImagen: SafeUrl | null = null;
  varLote:string;
  blod: Blob;
  url: String;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;

  @ViewChild(MdbTablePaginationComponent) mdbTablePaginationDet: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTableDet: MdbTableDirective;
  previous: any = [];
  @ViewChild('lgModal') public lgModal: ModalDirective;

  constructor(private apiConfiEtiqueta: ConfigetiquetaService, private sanitizer: DomSanitizer, private apiPrint: ImpresionService, private datePipe: DatePipe, private api: OrdenService, private ruter: Router, private alertService: AlertService) { }

  ngOnInit(): void {
    this.lista = [];
    this.fecha =this.datePipe.transform(new Date(), "dd-MM-yyyy");
    this.buscarOrdenes();
  }
  @HostListener('input') oninput() {
    this.searchItems();
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.lista = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.lista = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

  generarLote() {
    this.api.obtenerLote().subscribe((
      data: BatchModule[]) => {
      this.batch = data;
      console.log(this.batch);
      this.recepcion = [];
      for (let o of this.detalles) {
        o.lote = this.batch[0].batch;
        this.habilitarLote = true;
        this.recepcionEntidad = new Recepcion();
        this.recepcionEntidad.batch = o.lote;
        this.recepcionEntidad.id_orden = this.documento;
        this.recepcionEntidad.id_producto = o.m_product_id;
        this.recepcionEntidad.cod_asociacion = o.groupbpartner;
        this.recepcionEntidad.product_value = o.value;
        this.recepcionEntidad.cantidad = o.qtyentered;
        this.recepcionEntidad.producto = o.descriptionProducto;
        this.recepcionEntidad.asociacion = o.namegroupbpartner;
        this.recepcion.push(this.recepcionEntidad);
      }

      this.api.registrarRecepcion(this.recepcion).subscribe((
        data) => {
        this.alertService.info(data)
      },


      );

    },

      err => this.alertService.danger('Problemas en servicio')
    );


  } 

  verDetalle(orden: OrdenModule) {
    this.documento = orden.documentno;
    this.api.detalleOrdenes(orden.documentno)
      .subscribe((
        data: DetalleModule[]) => {
        this.detalles = data;

        this.api.listarRecepcion(orden.documentno).subscribe((
          data: Recepcion[]) => {
          if (data.length > 0) {
            this.recepcion = data;
            this.habilitarLote = true;
            this.detalles.forEach(element => {
              element.lote = this.recepcion[0].batch;
            });
            this.alertService.info('Lote ya asignado..');

          } else {
            this.habilitarLote = false;
            this.alertService.warning('Lote no asigando...');
          }
        },

          err => this.alertService.danger('Problemas con el servicio..')
        );
        console.log(this.detalles);
        this.mdbTableDet.setDataSource(this.detalles);
        this.mdbTableDet.dataSourceChange();


      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
    this.lgModal.show();
  }


printEtiq(entidad1: DetalleModule){
  
  this.apiConfiEtiqueta.etiquetaxProducto(entidad1.value).subscribe((data: EtiquetaModule[]) => {
    this.varLote=entidad1.lote+' '+entidad1.groupbpartner+' '+entidad1.documentno+ ' '+ entidad1.m_product_id;
          data.forEach(element => {
            this.apiPrint.configEtiqueta(element.etiquetaNombre,this.varLote)
            .subscribe((
              data: ConfigEtiquetaModule) => {
                this.apiPrint.getEtiqueta(data.etiqueta).subscribe((file1) => {
                  this.blod = new Blob([file1], { type: 'application/pdf' });
                  const url1 = window.URL.createObjectURL(this.blod);
                  this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
                  var downloadURL = URL.createObjectURL(this.blod);
                  window.open(downloadURL);
                }
                );
           
              },
              err => this.alertService.danger('Error no hay  conexion..')
            );
        }
            ,
            err => this.alertService.danger('Error no hay  conexion..')
    
          );
    
        }
        );
    


}

  printEtiqueta(entidad1: DetalleModule) {

    this.apiConfiEtiqueta.etiquetaxProducto(entidad1.value).subscribe((data: EtiquetaModule[]) => {
this.varLote=entidad1.lote+' '+entidad1.groupbpartner+' '+entidad1.documentno+ ' '+ entidad1.m_product_id;
      data.forEach(element => {
        if (element.etiquetaNombre === 'Satori') {
        

        }
        if (element.etiquetaNombre === 'Satori Maritimo') {
          this.apiPrint.getEtiquetaSatoriMartimo(this.varLote).subscribe((file1) => {
            this.blod = new Blob([file1], { type: 'application/pdf' });
            const url1 = window.URL.createObjectURL(this.blod);
            this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
            var downloadURL = URL.createObjectURL(this.blod);
            window.open(downloadURL);

          }
          );

        }

       
          

          if (element.etiquetaNombre === 'GoodFarma_asobananito' && entidad1.groupbpartner=='ASOB NGG') {
            this.apiPrint.getEtiquetaGoodFarmerASOBANANITO(this.varLote).subscribe((file1) => {
              this.blod = new Blob([file1], { type: 'application/pdf' });
              const url1 = window.URL.createObjectURL(this.blod);
              this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
              var downloadURL = URL.createObjectURL(this.blod);
              window.open(downloadURL);
  
            }
            
          );

        }

        if (element.etiquetaNombre === 'GoodFarma_asoagcar') {
          this.apiPrint.getEtiquetaGoodFarmerASOGAR(this.varLote).subscribe((file1) => {
            this.blod = new Blob([file1], { type: 'application/pdf' });
            const url1 = window.URL.createObjectURL(this.blod);
            this.urlImagen = this.sanitizer.bypassSecurityTrustUrl(url1);
            var downloadURL = URL.createObjectURL(this.blod);
            window.open(downloadURL);

          }
          
        );

      }

      }
        ,
        err => this.alertService.danger('Error no hay  conexion..')

      );

    }
    );

  }




  buscarOrdenes() {
    this.searchText = '';
    this.api.listarOrdenes(this.datePipe.transform(this.fecha, "dd-MM-yyyy"))
      .subscribe((
        data: OrdenModule[]) => {
        this.lista = data;
        console.log(this.lista);

        this.mdbTable.setDataSource(this.lista);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
  }

}
